// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component } from "vue-property-decorator";

//Components
import WithRender from "Components/WorkbenchProducts/workbench-products.html";

//Child Components
import ProductCard from "Components/Shared/ProductCard/ProductCard";

@WithRender
@Component({
	components: {
		ProductCard
	}
})

export default class WorkbenchProducts extends Vue {
	products:any = document.querySelector('.js-workbench-products') ? JSON.parse(document.querySelector('.js-workbench-products').getAttribute('data-products')) : null;
	translations:any = document.querySelector('.js-page-data') ? JSON.parse(document.querySelector('.js-page-data').getAttribute('data-translations')) : null;

	created() {
		let vm = this;
	}
}
